import { MapLayout } from 'layouts';

const Home = () => {
  return <MapLayout />;
};

export default Home;
